export type ActionPath = 'MapaAprendizagem' | 'ListaCategoria' | 'Recomendação';

export type DialogFlowPayloadType = 'chips' | 'image' | 'action';

export interface RichContentOption {
    text: string;
    property?: string;
    value?: string | number | boolean | number[];
}

export interface RichContent {
    options?: RichContentOption[];
    rawUrl?: string;
    type: DialogFlowPayloadType;
    path?: ActionPath;
    multipleSelection?: boolean;
    width?: number;
    height?: number;
    recomendationResult?: any; // TODO(dias): BotRecommendationResult
}

export interface DialogFlowMessagePayload {
    richContent: [[RichContent]];
}

export enum DialogflowMessageType {
    MESSAGE = 'MESSAGE',
    PAYLOAD = 'PAYLOAD',
    USER = 'USER',
}

export interface DialogFlowMessage {
    message: string;
    messageType: DialogflowMessageType;
    payload: DialogFlowMessagePayload;
}
